import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import "../Home/home.css"
import { FiUser } from "react-icons/fi";
import { FaHome, FaRegUser } from 'react-icons/fa';
import { SlWallet } from 'react-icons/sl';
import { AiOutlineHistory } from 'react-icons/ai';
import { PiHandWithdraw } from 'react-icons/pi';
import { LuBoxes } from 'react-icons/lu';
import { TbLockPassword } from 'react-icons/tb';
import { MdLogout } from 'react-icons/md';
import { RxHamburgerMenu } from 'react-icons/rx';
import { GiArmorUpgrade } from "react-icons/gi";
import { FcAbout } from "react-icons/fc";
import { PiCertificate } from "react-icons/pi";
import { LuFileTerminal } from "react-icons/lu";
import { RiRefund2Line } from "react-icons/ri";
import { FaQq } from "react-icons/fa6";
const GameHeader = () => {
    let navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [profileDrop, setProfileDrop] = useState(false);
    const [userData, setItems] = useState();
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        setItems(items)
    }, []);
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const profileDrag = () => {
        setProfileDrop(!profileDrop);
    };
    const startcarrier = () => {
        navigate(`/Optimization`);
    };
    const handleHome = () => {
        navigate(`/Home`);
    }
    const handleHistory = () => {
        navigate(`/History`);
    }
    const handleProfile = () => {
        navigate(`/Profile`);
    }
    const resetPassword = () => {
        navigate(`/ResetPassword`);
    }
    const recharge = () => {
        navigate(`/Recharge`);
    }
    const waletInfo = () => {
        navigate(`/waletInfo`);
    }
    const terms = () => {
        navigate(`/terms`);
    }
    const About = () => {
        navigate(`/About`);
    }
    const FAQs = () => {
        navigate(`/FAQs`);
    }
    const login = () => {
        navigate(`/login`);
    }
    const Certificate = () => {
        navigate(`/Certificate`);
    }
    const UpgradeLevel = () => {
        navigate(`/UpgradeLevel`);
    }
    const Support = () => {
        navigate(`/Support`);
    }
    const handleOut = () => {
        localStorage.clear();
        window.location.href = 'https://www.epicgame.me/';
    };
    const Withdrawal = () => {
        navigate(`/Withdrawal`);
    }


    return (
        <div className="smal">
            <div className='d-flex justify-content-between'>
                <div className='mainbtnGry flex-end gap-2'>
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                        <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                            <RxHamburgerMenu size={30} color='#fff' />
                        </DropdownToggle>
                        <DropdownMenu className='mt-3'>
                            {!userData?.Email ? (
                                <>
                                    <DropdownItem className='gap-3 d-flex' onClick={login}><FaHome size={30} /><div className='fonthead'>Login</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex' onClick={Certificate}><SlWallet size={30} /><div className='fonthead'>Certificate</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex' onClick={UpgradeLevel}><GiArmorUpgrade /><div className='fonthead'>Membership Upgrade</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex' onClick={Support}><FaHome /><div className='fonthead'>Support</div></DropdownItem>
                                </>
                            ) : (
                                <>
                                    <DropdownItem className='gap-3 d-flex' onClick={handleHome}><FaHome size={30} /><div className='fonthead'>Home</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex my-3' onClick={startcarrier}><LuBoxes size={30} /><div className='fonthead'>Start Your Career</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex' onClick={handleHistory}><AiOutlineHistory size={30} /><div className='fonthead'>History</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex my-3' onClick={Withdrawal}><PiHandWithdraw size={30} /><div className='fonthead'>Withdraw</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex mb-4' onClick={waletInfo}><SlWallet size={30} /><div className='fonthead'>Wallet Info</div></DropdownItem>

                                    {/* --- Separator --- */}
                                    <DropdownItem divider />

                                    <DropdownItem className='gap-3 d-flex mt-3' onClick={UpgradeLevel}><GiArmorUpgrade size={30} /><div className='fonthead'>Membership Upgrade</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex mt-3' onClick={About}><FcAbout size={30} /><div className='fonthead'>About Epic</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex my-3' onClick={Certificate}><PiCertificate size={30} /><div className='fonthead'>Certificate</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex' onClick={terms}><LuFileTerminal size={30} /><div className='fonthead'>Terms & Conditions</div></DropdownItem>
                                    <DropdownItem className='gap-3 d-flex mt-3' onClick={FAQs}><FaQq size={30} /><div className='fonthead'>FAQs</div></DropdownItem>
                                </>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                </div>

                {userData?.Email && (
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={profileDrop} toggle={profileDrag}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={profileDrop}>
                                <FiUser size={30} color='#fff' />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem className='gap-3 d-flex' onClick={handleProfile}><FaRegUser size={30}  /><div className='fonthead'>Profile</div></DropdownItem>
                                <DropdownItem className='gap-3 d-flex my-3' onClick={resetPassword}><TbLockPassword size={30}  /><div className='fonthead'>Reset Password</div></DropdownItem>
                                <DropdownItem className='gap-3 d-flex mb-4' onClick={recharge}><RiRefund2Line size={30}  /><div className='fonthead'>Recharge</div></DropdownItem>

                                {/* --- Separator --- */}
                                <DropdownItem divider />

                                <DropdownItem className='gap-3 d-flex mt-3' onClick={handleOut}><MdLogout size={30}  /><div className='fonthead'>Logout</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                )}
            </div>
        </div>

    );
};

export default GameHeader;
